import React, { useEffect, useRef } from 'react'

import { useSelector } from 'react-redux'

// Hooks

import GetStatesByCountry from '../../../../hooks/GetStatesByCountry';
import GetCitiesByState from '../../../../hooks/GetCitiesByState';
import GetMunicipalitiesByState from '../../../../hooks/GetMunicipalitiesByState';
import GetParishesByMunicipality from '../../../../hooks/GetParishesByMunicipality';
import GetSectorsByState from '../../../../hooks/GetSectorsByState';
import GetPhoneAreaCodesByState from '../../../../hooks/GetPhoneAreaCodesByState';

// Components

import DropDownInput from '../../../UI/FormInput/DropDownInput';
import TextInput from '../../../UI/FormInput/TextInput';
import MaskInput from '../../../UI/FormInput/MaskInput';
import FormInputGroup from '../../../UI/FormInputGroup/FormInputGroup';
import RadioInput from '../../../UI/FormInput/RadioInput';
import SectionHeading from '../../../UI/SectionHeading/SectionHeading';
import JobLocaleTypeFields from './JobLocaleTypeFields';

// Utilities

import { formatDropDownOptions, formatDropDownOptionsAlt, formatDropDownOptionsWithValueAsName } from '../../../../utilities/helper-functions';

// Constants

import { PHONE_MASK_FORMAT, PHONE_AREA_CODE_MASK_FORMAT, INTERNATIONAL_FULL_PHONE_MASK_FORMAT } from '../../../../config/constants';

import { jobAddressValues } from './InitialValues';

export default function JobAddressFields({ formik, index }) {
    const { getStatesIsLoading, getStatesError, states, handleGetStatesByCountry, setStates } = GetStatesByCountry();
    const { getCitiesIsLoading, getCitiesError, cities, handleGetCitiesByState, setCities } = GetCitiesByState();
    const { getMunicipalitiesIsLoading, getMunicipalitiesError, municipalities, handleGetMunicipalitiesByState, setMunicipalities } = GetMunicipalitiesByState();
    const { getParishesIsLoading, getParishesError, parishes, handleGetParishesByMunicipality, setParishes } = GetParishesByMunicipality();
    const { getSectorsIsLoading, getSectorsError, sectors, handleGetSectorsByState, setSectors } = GetSectorsByState();
    const { getPhoneAreaCodesIsLoading, getPhoneAreaCodesError, phoneAreaCodes, handleGetPhoneAreaCodesByState } = GetPhoneAreaCodesByState();

    // State
    const dropDownOptions = useSelector((state) => state.options.dropDownOptions);

    const prevPais = useRef(null);

    const previousSameAddress = useRef(formik.values?.jobReferences[index]?.address?.sameAddress);

    // Get the States by Country

    useEffect(() => {
        const pais = formik.values?.jobReferences[index]?.address?.pais;

        if (!pais) return;

        if (pais === '0') {
            handleGetStatesByCountry(pais);
        }

        const item = dropDownOptions?.data?.countries?.find((item) => item.value === pais);
        formik.setFieldValue(`jobReferences.${index}.address.nombrePais`, item?.name ?? '');

        if (prevPais.current !== null && prevPais.current !== pais) {
            setTimeout(() => {
                formik.setFieldValue(`jobReferences.${index}.address.telefono1.codigoArea`, '');
                formik.setFieldValue(`jobReferences.${index}.address.telefono1.numero`, '');
            }, 0);
        }

        prevPais.current = pais;

    }, [formik.values?.jobReferences[index]?.address?.pais]);


    // Get the Cities by State

    useEffect(() => {
        if (formik.values?.jobReferences[index]?.address?.entidad) {
            handleGetCitiesByState(formik.values?.jobReferences[index]?.address?.entidad);
            // if (formik.values?.jobReferences[index]?.address?.sameAddress === 'no') {
            //     setParishes([]);
            //     formik.setFieldValue(`jobReferences.${index}.address.ciudad`, '');
            //     formik.setFieldValue(`jobReferences.${index}.address.municipio`, '');
            //     formik.setFieldValue(`jobReferences.${index}.address.parroquia`, '');
            //     formik.setFieldValue(`jobReferences.${index}.address.urbanizacion`, '');
            // }
        }
    }, [handleGetCitiesByState, formik.values?.jobReferences[index]?.address?.entidad])


    // Get the Municipality by State 

    useEffect(() => {
        if (formik.values?.jobReferences[index]?.address?.entidad) {
            handleGetMunicipalitiesByState(formik.values?.jobReferences[index]?.address?.entidad);
        }
    }, [handleGetMunicipalitiesByState, formik.values?.jobReferences[index]?.address?.entidad])


    // Get the Parishes by Municipality 

    useEffect(() => {
        if (formik.values?.jobReferences[index]?.address?.municipio) {
            // if (formik.values?.jobReferences[index]?.address?.sameAddress === 'no') {
            //     formik.setFieldValue(`jobReferences.${index}.address.parroquia`, '');
            // }
            handleGetParishesByMunicipality(formik.values?.jobReferences[index]?.address?.municipio);
        }
    }, [handleGetParishesByMunicipality, formik.values?.jobReferences[index]?.address?.municipio])


    // Get the Sectors by State

    useEffect(() => {
        if (formik.values?.jobReferences[index]?.address?.entidad) {
            handleGetSectorsByState(formik.values?.jobReferences[index]?.address?.entidad);
        }
    }, [handleGetSectorsByState, formik.values?.jobReferences[index]?.address?.entidad])


    // Get Phone Area Codes by State

    useEffect(() => {
        if (formik.values?.jobReferences[index]?.address?.entidad) {
            handleGetPhoneAreaCodesByState(formik.values?.jobReferences[index]?.address?.entidad);
        }
    }, [formik.values?.jobReferences[index]?.address?.entidad])


    // Set job address fields if the address is the same as home address

    useEffect(() => {
        const current = formik.values?.jobReferences[index]?.address?.sameAddress;

        if (previousSameAddress.current === current) {
            return;
        }

        if (current === 'si') {
            const address = {
                ...formik.values?.jobReferences[index]?.address,
                ...formik.values?.direccion,
                avenida: formik.values?.direccion?.calle,
                piso: formik.values?.direccion?.piso || formik.values?.direccion?.nivel,
            };
            formik.setFieldValue(`jobReferences.${index}.address`, address);
        }
        
        if (current === 'no') {
            // if (!formik.values?.jobReferences[index]?.address?.pais) {
                const address = {
                    ...jobAddressValues,
                    sameAddress: formik.values?.jobReferences[index]?.address?.sameAddress,
                };
                formik.setFieldValue(`jobReferences.${index}.address`, address);
                setStates([]);
                setCities([]);
                setMunicipalities([]);
                setParishes([]);
                setSectors([]);
            // }
        }
        previousSameAddress.current = current;
    }, [formik.values?.jobReferences[index]?.address?.sameAddress])

    return (
        <>

            {index !== 'empleo' &&
                <RadioInput
                    formik={formik}
                    fieldName={`jobReferences.${index}.address.sameAddress`}
                    label={'¿La dirección de empleo es igual a la del domicilio?'}
                    options={[{ label: 'Sí', value: 'si' }, { label: 'No', value: 'no' },]}
                    isGroup={true}
                    isRequired={true}
                />}

            {formik.values?.jobReferences[index]?.address?.sameAddress &&
                <FormInputGroup>
                    <DropDownInput
                        formik={formik}
                        fieldName={`jobReferences.${index}.address.pais`}
                        label={'País'}
                        options={formatDropDownOptions(dropDownOptions?.data?.countries)}
                        isRequired={true}
                    />

                    {(formik.values?.jobReferences[index]?.address?.pais === '' || formik.values?.jobReferences[index]?.address?.pais === '0') &&
                        <>

                            <DropDownInput
                                formik={formik}
                                fieldName={`jobReferences.${index}.address.entidad`}
                                label={'Entidad'}
                                options={formatDropDownOptions(states)}
                                isRequired={true}
                                disabled={states?.length === 0 || getStatesIsLoading || getStatesError}
                                loading={getStatesIsLoading}
                            />

                            <DropDownInput
                                formik={formik}
                                fieldName={`jobReferences.${index}.address.ciudad`}
                                label={'Ciudad'}
                                options={formatDropDownOptions(cities)}
                                isRequired={true}
                                disabled={cities?.length === 0 || getCitiesIsLoading || getCitiesError}
                                loading={getCitiesIsLoading}
                            />

                            <DropDownInput
                                formik={formik}
                                fieldName={`jobReferences.${index}.address.municipio`}
                                label={'Municipio'}
                                options={formatDropDownOptions(municipalities)}
                                isRequired={true}
                                disabled={municipalities?.length === 0 || getMunicipalitiesIsLoading || getMunicipalitiesError}
                                loading={getMunicipalitiesIsLoading}
                            />

                            <DropDownInput
                                formik={formik}
                                fieldName={`jobReferences.${index}.address.parroquia`}
                                label={'Parroquia'}
                                options={formatDropDownOptions(parishes)}
                                isRequired={true}
                                disabled={parishes?.length === 0 || getParishesIsLoading || getParishesError}
                                loading={getParishesIsLoading}
                            />

                            <DropDownInput
                                formik={formik}
                                fieldName={`jobReferences.${index}.address.urbanizacion`}
                                label={'Urbanización, Sector, Barrio'}
                                options={formatDropDownOptions(sectors)}
                                isRequired={true}
                                disabled={sectors?.length === 0 || getSectorsIsLoading || getSectorsError}
                                loading={getSectorsIsLoading}
                            />

                        </>}
                </FormInputGroup>}

            {formik.values?.jobReferences[index]?.address?.sameAddress && (formik.values?.jobReferences[index]?.address?.pais === '' || formik.values?.jobReferences[index]?.address?.pais === '0') &&
                <>
                    <FormInputGroup>

                        <RadioInput
                            formik={formik}
                            fieldName={`jobReferences.${index}.address.callecarretera`}
                            label={'Seleccione un tipo'}
                            options={[{ label: 'Calle', value: 'calle' }, { label: 'Carrera', value: 'carrera' }]}
                            isGroup={true}
                            isRequired={true}
                        />

                        <TextInput
                            formik={formik}
                            fieldName={`jobReferences.${index}.address.calle`}
                            label={'Calle / Carrera'}
                            maxLength={80}
                        />

                    </FormInputGroup>

                    <FormInputGroup>

                        <TextInput
                            formik={formik}
                            fieldName={`jobReferences.${index}.address.avenida`}
                            label={'Avenida'}
                            maxLength={80}
                        />

                        <TextInput
                            formik={formik}
                            fieldName={`jobReferences.${index}.address.esquina`}
                            label={'Esquina'}
                            maxLength={80}
                        />

                        <TextInput
                            formik={formik}
                            fieldName={`jobReferences.${index}.address.observaciones`}
                            label={"Observaciones"}
                            maxLength={120}
                        />

                        <DropDownInput
                            formik={formik}
                            fieldName={`jobReferences.${index}.address.tipoInmueble`}
                            label={'Tipo de Inmueble'}
                            options={formatDropDownOptions(dropDownOptions?.data?.propertyTypes)}
                            isRequired={true}
                        />

                    </FormInputGroup>

                    {formik.errors.jobReferences?.[index]?.address?._direccionGroup && (
                        <small className="p-error">
                            {formik.errors.jobReferences?.[index]?.address?._direccionGroup}
                        </small>
                    )}

                </>}

            {(formik.values?.jobReferences[index]?.address?.pais === '0' && formik.values?.jobReferences[index]?.address?.tipoInmueble) && (
                <FormInputGroup>

                    <TextInput
                        formik={formik}
                        fieldName={`jobReferences.${index}.address.nombreInmueble`}
                        label={'Nombre / Identificación del Inmueble'}
                        maxLength={80}
                        isRequired={true}
                    />

                    <JobLocaleTypeFields
                        formik={formik}
                        index={index}
                        dropDownOptions={dropDownOptions}
                    />

                </FormInputGroup>)}

            {(formik.values?.jobReferences[index]?.address?.pais !== '' && formik.values?.jobReferences[index]?.address?.pais !== '0') &&
                <TextInput
                    formik={formik}
                    fieldName={`jobReferences.${index}.address.descDireccion`}
                    label={"Dirección"}
                    maxLength={120}
                    isRequired={true}
                />}

            {formik.values?.jobReferences[index]?.address?.sameAddress &&
                <>

                    <SectionHeading text={'Teléfono'} isSubHeading />

                    <div className='form-field-phone-group'>

                        <DropDownInput
                            formik={formik}
                            fieldName={`jobReferences.${index}.address.telefono1.tipo`}
                            label={'Tipo de Teléfono'}
                            options={formatDropDownOptions(dropDownOptions?.data?.phoneTypes)}
                            isRequired={true}
                        />

                        {formik.values?.jobReferences[index]?.address?.pais !== '0' &&
                            <MaskInput
                                formik={formik}
                                fieldName={`jobReferences.${index}.address.telefono1.codigoArea`}
                                label={'Código País y/o Área'}
                                mask={PHONE_AREA_CODE_MASK_FORMAT}
                                isRequired={true}
                            />}

                        {formik.values?.jobReferences[index]?.address?.pais === '0' &&
                            <DropDownInput
                                formik={formik}
                                fieldName={`jobReferences.${index}.address.telefono1.codigoArea`}
                                label={'Código País y/o Área'}
                                options={formik.values?.jobReferences[index]?.address?.telefono1?.tipo === 'T' ? formatDropDownOptionsAlt(phoneAreaCodes) : formatDropDownOptionsWithValueAsName(dropDownOptions?.data?.phoneCodes)}
                                isRequired={true}
                                disabled={phoneAreaCodes?.length === 0 || getPhoneAreaCodesIsLoading || getPhoneAreaCodesError}
                                loading={getPhoneAreaCodesIsLoading}
                            />}

                        <MaskInput
                            formik={formik}
                            fieldName={`jobReferences.${index}.address.telefono1.numero`}
                            label={'Número de teléfono'}
                            mask={formik.values?.jobReferences[index]?.address?.pais === '0' ? PHONE_MASK_FORMAT : INTERNATIONAL_FULL_PHONE_MASK_FORMAT}
                            isRequired={true}
                        />

                    </div>
                </>}

        </>
    )
}
